export enum VideoType {
    Local=0,
    Youtube=1,
    Vimeo=2,
    OtherEmbedded=3,
    WithArchiveLink=4
}